module.exports = __webpack_public_path__ + "img/bdw9bqY.a8a31c1e.png";